// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"fL-z","upvoteIcon":"gL-z","downvoteIcon":"hL-z","feedbackIcon":"iL-z"};